// src/utils.js
export function createPageUrl(pageName) {
    return `/${pageName.toLowerCase()}`;
}